export const ACCOUNT_PAGE_STATE = {
    DEFAULT: 0,
    EDIT: 1,
    DELETE: 2
}